import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from '@herit-fe/heritage-ui';
import { UI_TEXT } from '@/shared/languages';

export interface MonthGridProps {
  /** 표시 중인 연도(뷰 상태는 호출처 소유 — 열 때 동기화 정책이 필드마다 다름). */
  year: number;
  onYearChange: (year: number) => void;
  /** 선택된 월 `yyyy-MM`(미선택이면 생략). */
  selected?: string;
  /** 선택 가능 하한/상한 `yyyy-MM`. 일 단위 제약(`yyyy-MM-dd`)에서 오면 앞 7자만 잘라 넘긴다 — 월의
   *  일부라도 선택 가능하면 그 월은 열어야 하므로 월 단위 절삭이 곧 올바른 경계다. */
  min?: string;
  max?: string;
  onSelect: (yyyymm: string) => void;
}

/**
 * 12개월 그리드 + 연도 네비 — `MonthField`(월 자체가 값) 와 `DateField` 의 월 점프 뷰가 공유한다.
 * 값 형식은 `yyyy-MM` 문자열 하나로 통일(문자열 비교만으로 min/max 판정 — Date 파싱·타임존 관여 없음).
 */
export function MonthGrid({ year, onYearChange, selected, min, max, onSelect }: MonthGridProps) {
  return (
    <>
      <div className="flex items-center justify-between pb-2">
        <Button
          type="button"
          variant="ghost"
          size="icon"
          className="size-7"
          onClick={() => onYearChange(year - 1)}
          aria-label={UI_TEXT.MONTH_FIELD_PREV_YEAR}
        >
          <ChevronLeft className="size-4" />
        </Button>
        <span className="text-sm font-medium text-foreground">{year}</span>
        <Button
          type="button"
          variant="ghost"
          size="icon"
          className="size-7"
          onClick={() => onYearChange(year + 1)}
          aria-label={UI_TEXT.MONTH_FIELD_NEXT_YEAR}
        >
          <ChevronRight className="size-4" />
        </Button>
      </div>
      <div className="grid grid-cols-3 gap-1">
        {Array.from({ length: 12 }, (_, i) => {
          const ym = `${year}-${String(i + 1).padStart(2, '0')}`;
          return (
            <Button
              key={ym}
              type="button"
              variant={ym === selected ? 'default' : 'ghost'}
              size="sm"
              disabled={Boolean((min && ym < min) || (max && ym > max))}
              onClick={() => onSelect(ym)}
            >
              {UI_TEXT.MONTH_LABEL(i + 1)}
            </Button>
          );
        })}
      </div>
    </>
  );
}
